import type { InputData } from "@/Components/Extend/HTMLEditor/interfaces";
import type { SignDocumentApi } from "@/Modules/SignDocuments/Models/Api";

import { get2, patch2, post2, remove2 } from "@/Services/TherapyApi/utils/FunctionalTherapyApi";

export const getAllSignDocuments = async (): Promise<SignDocumentApi[]> => {
  return get2<void, SignDocumentApi[]>("v1.0/sign_documents");
};

export const getSignDocument = async (uuid: string): Promise<SignDocumentApi> => {
  return get2<void, SignDocumentApi>(`v1.0/sign_documents/${uuid}`);
};

export const getSignDocumentDownloadLink = async (uuid: string): Promise<{ signed_url: string }> => {
  return get2<void, { signed_url: string }>(`v1.0/sign_documents/${uuid}/download_link`);
};

export const doSign = async (documentId: string, responses: InputData[]): Promise<SignDocumentApi> => {
  return post2<{ responses: InputData[] }, SignDocumentApi>(`v1.0/sign_documents/${documentId}`, {
    responses,
  });
};

export const updateResponses = async (
  documentId: string,
  responses: InputData[]
): Promise<SignDocumentApi> => {
  return patch2<{ responses: InputData[] }, SignDocumentApi>(`v1.0/sign_documents/${documentId}`, {
    responses,
  });
};

export const cancel = async (documentId: string): Promise<SignDocumentApi> => {
  return remove2<void, SignDocumentApi>(`v1.0/sign_documents/${documentId}`);
};

export default { getAllSignDocuments, getSignDocument, doSign, cancel };
